var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12001 1.29007L6.00001 5.17007L9.88001 1.29007C9.97259 1.19749 10.0825 1.12405 10.2035 1.07394C10.3244 1.02384 10.4541 0.998047 10.585 0.998047C10.7159 0.998047 10.8456 1.02384 10.9665 1.07394C11.0875 1.12405 11.1974 1.19749 11.29 1.29007C11.3826 1.38265 11.456 1.49256 11.5061 1.61352C11.5562 1.73449 11.582 1.86414 11.582 1.99507C11.582 2.126 11.5562 2.25565 11.5061 2.37661C11.456 2.49757 11.3826 2.60749 11.29 2.70007L6.70001 7.29007C6.60749 7.38277 6.4976 7.45632 6.37663 7.5065C6.25566 7.55668 6.12597 7.58251 5.99501 7.58251C5.86404 7.58251 5.73435 7.55668 5.61338 7.5065C5.49241 7.45632 5.38252 7.38277 5.29001 7.29007L0.700006 2.70007C0.607302 2.60755 0.533755 2.49767 0.483573 2.37669C0.433392 2.25572 0.407562 2.12604 0.407562 1.99507C0.407562 1.8641 0.433392 1.73442 0.483573 1.61344C0.533755 1.49247 0.607302 1.38258 0.700006 1.29007C1.09001 0.910068 1.73001 0.900068 2.12001 1.29007Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2ff4c089895f41b595a8047891fd47b3.svg";
export { ForwardRef as ReactComponent };